export const STATIC_HOST = 'https://static2.aastatic.com.ar/';